import { CaretDownFilled } from '@ant-design/icons';
import { Dropdown } from 'antd';
import React from 'react';
import styled from 'styled-components';
import OptionsDropdownMenu from './OptionsDropdownMenu';
import { capitalizeFirstLetterOnly } from '../../shared/textUtil';
import { DisplayedFilterOption } from './mapFilterOption';
import { SearchFilterLabel } from './styledComponents';
import { useTranslation } from '../../../i18n/useTranslation';

export const IconWrapper = styled.div`
    margin-right: 8px;
    display: flex;
    svg {
        height: 14px;
        width: 14px;
    }
`;

interface Props {
    filterOptions: DisplayedFilterOption[];
    isMenuOpen: boolean;
    numActiveFilters: number;
    filterIcon: JSX.Element | null;
    displayName: string;
    searchQuery: string;
    loading: boolean;
    field?: string;
    updateIsMenuOpen: (isOpen: boolean) => void;
    setSearchQuery: (query: string) => void;
    updateFilters: () => void;
}

export default function SearchFilterView({
    filterOptions,
    isMenuOpen,
    numActiveFilters,
    filterIcon,
    displayName,
    searchQuery,
    loading,
    field,
    updateIsMenuOpen,
    setSearchQuery,
    updateFilters,
}: Props) {
    const { t } = useTranslation();
    const filterOps = filterOptions.filter((option) => option.displayName !== 'DataHub');

    return (
        <Dropdown
            trigger={['click']}
            menu={{ items: filterOps }}
            open={isMenuOpen}
            onOpenChange={(open) => updateIsMenuOpen(open)}
            dropdownRender={(menu) => (
                <OptionsDropdownMenu
                    menu={menu}
                    field={field}
                    updateFilters={updateFilters}
                    searchQuery={searchQuery}
                    updateSearchQuery={setSearchQuery}
                    isLoading={loading}
                    searchPlaceholder={displayName}
                />
            )}
        >
            <SearchFilterLabel
                onClick={() => updateIsMenuOpen(!isMenuOpen)}
                isActive={!!numActiveFilters}
                aria-label={`${capitalizeFirstLetterOnly(displayName)} ${
                    numActiveFilters ? `(${numActiveFilters}) ` : ''
                }`}
                data-testid={`filter-dropdown-${capitalizeFirstLetterOnly(displayName)}`}
            >
                {filterIcon && <IconWrapper aria-hidden="true">{filterIcon}</IconWrapper>}
                {t(capitalizeFirstLetterOnly(displayName) || '')} {numActiveFilters ? `(${numActiveFilters}) ` : ''}
                <CaretDownFilled aria-hidden="true" style={{ fontSize: '12px', height: '12px' }} />
            </SearchFilterLabel>
        </Dropdown>
    );
}
